'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sellerCatalogs = require('./remote/sellerCatalogs');

var SellerCatalogs = {
    fetchSellerEndedCatalogsById: _sellerCatalogs.SellerCatalogsRemote.fetchSellerEndedCatalogsById,
    fetchSellerPreviewCatalogsById: _sellerCatalogs.SellerCatalogsRemote.fetchSellerPreviewCatalogsById,
    fetchSellerUpcomingCatalogsById: _sellerCatalogs.SellerCatalogsRemote.fetchSellerUpcomingCatalogsById
};

exports.default = SellerCatalogs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/sellerCatalogs.js
// module id = kIRm
// module chunks = 60